import React, { Component } from "react";
import { linkData } from "./linkData";
import { socialData } from "./socialData";
import { dbs, app } from "../Config/db";
import axios from "axios";

//import { useHistory } from "react-router-dom";
const ProductContext = React.createContext();

const API_URL = process.env.REACT_APP_API_URL;
class ProductProvider extends Component {
  // states (Variablerne)
  state = {
    menu: [],

    categorieNames: [],
    burger: [],
    pasta: [],
    ekstras: [],
    dressing_pizza: false,
    sidebarOpen: false,
    cartOpen: false,
    links: linkData,
    socialLinks: socialData,
    cart: [],
    cartitems: 0,
    cartSubTotal: 0,
    cartTax: 0,
    cartTotal: 0,
    storeProducts: [],
    filteredProducts: [],
    singleProduct: {},
    singleCategorie: [],
    loading: true,
    search: "",
    productNr: 0,
    productName: "",
    productTopping: "",
    price: 0,
    price1: 0,
    price2: 0,
    nyproductNr: 0,
    nyproductName: "",
    nyproductTopping: "",
    nyprice: 0,
    nyprice1: 0,
    nyprice2: 0,
    pricesingle: 0,
    category: "Klassisk PIZZA",
    segments: [
      { name: "Almindelig" },
      { name: "Deeppan" },
      { name: "Familie" },
    ],
    burgerSegments: [{ name: "Almindelig" }, { name: "Hjemmelavet" }],
    selected: 0,
    extratopping: [],
    toppingprice: 12,
    dressingprice: 5,
    productprice: 0,
    size: "",
    user: null,
    navn: "",
    message: "",
    adress: "",
    postnr: "",
    telefon: "",
    email: "",
    emailerror: "",
    password: "",
    passworderror: "",
    haslogged: false,
    deliveryOption: "Hent selv",
    deliveryPrice: 0,
    errorDelivery: "",
    nrToDelete: 0,
    productToDelete: {},
    modalOpen: false,
    errors: {
      navn: "",
      adress: "",
      postnr: "",
      email: "",
      telefon: "",
      termsAccepted: false,
      submitAttempted: false,
    },
  };

  // Data hentning fra database og set dem på states
  //  fetchdata = async () => {

  ////////////////////////////////Firebase data inhentnong////////////////////

  // const pizza = await dbs.collection("Klassisk PIZZA").get();
  // const data = pizza.docs.map((doc) => doc.data());
  // const burgers = await dbs.collection("Burgers").get();
  // const burgersdata = burgers.docs.map((doc) => doc.data());
  // const pastas = await dbs.collection("Pasta").get();
  // const pastasdata = pastas.docs.map((doc) => doc.data());

  // const extras = await dbs.collection("Ekstras").get();
  //   const exstrasdata = extras.docs.map((doc) => doc.data());
  /////////////////////////////////////////////////////////////////////////////////

  // }

  // set produkterne på menu og sorter categorie
  setProductOnMenu = () => {
    this.fetchdata().then(() => {
      let catname = this.state.filteredProducts.map((item) => item.category);

      let sortedcat = new Set(catname);
      let bagtoarraycat = [...sortedcat];
      let sortedcats = bagtoarraycat.filter((item) => item !== undefined);
      this.setState({
        categorieNames: sortedcats,
      });
      //this.authListener();
    });
  };
  //functioner der skal arbejde når siden mounter
  componentDidMount() {
    this.setProductOnMenu();
  }

  /////////////////////////////////////////////////////////////////////////////////////////////
  //                                 AdminLogin Firebase

  // login med password og email efter kontroleret i firebase
  handleLoginFirebase = () => {
    this.fetchdata();
    this.clearErrors();
    app
      .auth()
      .signInWithEmailAndPassword(this.state.email, this.state.password)
      .catch((err) => {
        switch (err.code) {
          case "auth/invalid-email":
          case "auth/user-disabled":
          case "auth/user-not-found":
            this.setState({
              emailerror: err.message,
            });
            break;
          case "auth/wrong-password":
            this.setState({
              passworderror: err.message,
            });
            break;
          default:
        }
      });
    //this.authListener();
  };

  // logud ud som admin
  handleLogoutFirebase = () => {
    app.auth().signOut();
    this.clearInputs();
  };
  // nulstilling af states email og password
  clearInputs = () => {
    this.setState({
      email: " ",
      password: " ",
    });
  };

  // nulstilling af form inputs i state

  clearFormInputs = () => {
    this.setState({
      navn: "",
      email: "",
      adress: "",
      telefon: "",
      postnr: "",
      message: "",
    });
  };

  // nulstilling af fejl meddelser
  clearErrors = () => {
    this.setState({
      emailerror: "",
      passworderror: "",
    });
  };
  // høre på systemet om der er admin loget ind
  // authListener = () => {
  // 	app.auth().onAuthStateChanged((user) => {
  // 		if(user){
  // 			this.clearInputs();
  // 			this.setState({
  // 				user:user,
  // 				email:user.email,
  // 				haslogged:true
  // 			});

  // 		}else{
  // 			this.setState({
  // 				user:null,
  // 				email:"",
  // 				haslogged:false
  // 			});
  // 		}
  // 	})

  // }

  /////////////////////////////////////////////////////////////////////////////////////////////
  //									Hnadle login sql with jwt
  handleLogin = () => {
    //const history = useHistory();
    this.fetchdata();
    this.clearErrors();
    const Auth = async () => {
      //e.preventDefault();
      try {
        const user = await axios.post(`${API_URL}/admin/adminlogin`, {
          email: this.state.email,
          password: this.state.password,
        });
        //history.push("/admin");

        this.setState({
          haslogged: true,
          user: user,
          email: user.email,
        });
      } catch (error) {
        if (error.response) {
          this.setState({
            emailerror: error.response.data.msg,
          });
        }
      }
    };
    Auth();
  };
  handleLogout = () => {
    const logOut = async () => {
      try {
        await axios.delete(`${API_URL}/admin/adminlogout`);
        // history.push('/');
        this.setState({
          haslogged: false,
          password: "",
        });
        //this.clearInputs();
      } catch (error) {
        console.log(error);
      }
    };
    logOut();
  };

  /////////////////////////////////////////////////////////////////////////////////////////////
  // 									Popup vindue

  // open popup vindue
  handleModalOpen = (product) => {
    if (product) {
      this.setState({
        nrToDelete: product.nr,
        productToDelete: product,
      });
    }
    this.setState({
      modalOpen: true,
    });
  };

  // lukke popup vindue
  handleModalClose = () => {
    this.setState({
      modalOpen: false,
    });
    console.log("in modal close");
  };

  /////////////////////////////////////////////////////////////////////////////////////////////
  // 									Admin CRUD

  /////////////////////////   SQL CRUD   ////////////////////////////
  fetchdata = async () => {
    console.log("API URL:", API_URL);
    const response = await axios.get(`${API_URL}/products`);
    const top = await axios.get(`${API_URL}/topping`);

    const pizza = response.data;
    const extra = top.data;

    this.setState({
      filteredProducts: pizza,
      menu: pizza,
      ekstras: extra,
    });
  };

  deleteProduct = async (singleProduct) => {
    console.log(singleProduct.nr);
    await axios.delete(`${API_URL}/products/${singleProduct.nr}`);
    this.handleModalClose();
    this.setState({
      nrToDelete: 0,
      productToDelete: {},
    });
    this.setProductOnMenu();
  };

  addProduct = async (e) => {
    //e.preventDefault();
    const res = await axios.post(`${API_URL}/products`, {
      nr: this.state.productNr,
      pName: this.state.productName,
      topping: this.state.productTopping,
      price: this.state.price,
      price1: this.state.price1,
      price2: this.state.price2,
      category: this.state.category,
    });

    this.setState({
      category: "",
      productName: "",
      productNr: "",
      price: 0,
      price1: 0,
      price2: 0,
      productTopping: "",
    });
    this.setProductOnMenu();
  };

  updateProduct = async (e) => {
    //e.preventDefault();
    await axios.patch(`${API_URL}/products/${e.nr}`, {
      category: this.state.category,
      pName: this.state.productName,
      nr: this.state.productNr,
      price: this.state.price,
      price1: this.state.price1,
      price2: this.state.price2,
      topping: this.state.productTopping,
    });
    this.setState({
      category: "",
      productName: "",
      productNr: "",
      price: 0,
      price1: 0,
      price2: 0,
      productTopping: "",
    });
    this.setProductOnMenu();
  };

  //////////// firebase CRUD  //////////////////////////
  // slette produkt
  // 	deleteProduct = async (singleproduct) => {
  // 		await dbs.collection(singleproduct.category).where("nr", "==",singleproduct.nr).get().then((qsnap)=>{
  // 			qsnap.forEach((doc)=>{
  // 				dbs.collection(singleproduct.category).doc(doc.id).delete();
  // 			})
  // 		})
  // 		this.handleModalClose();
  // 		this.setState({
  // 			nrToDelete:0,
  // 			productToDelete:{}
  // 		})
  // 		this.setProductOnMenu();
  // 	}

  // // updater produkt
  // 	updateProduct = async (singleproduct) => {

  // 		await dbs.collection(singleproduct.category).where("nr", "==",singleproduct.nr).get().then((qsnap)=>{
  // 			qsnap.forEach((doc)=>{
  // 				dbs.collection(singleproduct.category).doc(doc.id).update({
  // 					category:this.state.category,
  // 					name:this.state.productName,
  // 					nr:this.state.productNr,
  // 					price:this.state.price,
  // 					price1:this.state.price1,
  // 					price2:this.state.price2,
  // 					topping:this.state.productTopping
  // 				})
  // 				this.setState({
  // 					category:"",
  // 					productName:"",
  // 					productNr:"",
  // 					price:0,
  // 					price1:0,
  // 					price2:0,
  // 					productTopping:""
  // 				})
  // 			})
  // 		})
  // 	}

  // // tilføj produkt
  // 	addProduct = async () => {

  // 		await dbs.collection(this.state.category).add({
  // 			category:this.state.category,
  // 			name:this.state.productName,
  // 			nr:this.state.productNr,
  // 			price:this.state.price,
  // 			price1:this.state.price1,
  // 			price2:this.state.price2,
  // 			topping:this.state.productTopping
  // 		})
  // 		this.setState({
  // 			productName:"",
  // 			productNr:"",
  // 			price:0,
  // 			price1:0,
  // 			price2:0,
  // 			productTopping:""
  // 		})
  // 	}

  /////////////////////////////////////////////////////////////////////////////////////////////
  // 									Produkt sætning
  //   set Produkter med id
  setProducts = (products) => {
    let storeProducts = products.map((item) => {
      const { id } = item.sys;
      const product = { id, ...item.fields };
      return product;
    });

    this.setState(
      {
        storeProducts,
        filteredProducts: storeProducts,
        cart: this.getStorageCart(),
        singleProduct: this.getStorageProduct(),
        loading: false,
      },
      () => {
        this.addTotals();
      }
    );
  };
  // hent local gemte cart
  getStorageCart = () => {
    let cart;
    if (localStorage.getItem("cart")) {
      cart = JSON.parse(localStorage.getItem("cart"));
    } else {
      cart = [];
    }

    return cart;
  };

  // hent local gemte produckt
  getStorageProduct = () => {
    return localStorage.getItem("singleProduct")
      ? JSON.parse(localStorage.getItem("singleProduct"))
      : {};
  };

  // beregne cart total, moms, subtotal, antal produkter på kurv
  getTotals = () => {
    let subTotals = 0;
    let cartItems = 0;
    this.state.cart.forEach((item) => {
      subTotals += parseFloat(item.total);
      cartItems += item.count;
    });
    subTotals = parseFloat(subTotals) + this.state.deliveryPrice;
    subTotals = parseFloat(subTotals.toFixed(2));
    let total = subTotals;
    let tax = total * 0.2;
    tax = parseFloat(tax.toFixed(2));
    total = parseFloat(total.toFixed(2));

    return {
      cartItems,
      subTotals,
      tax,
      total,
    };
  };
  // set totaler på states
  addTotals = () => {
    const totals = this.getTotals();
    this.setState({
      cartItems: totals.cartItems,
      cartSubTotal: totals.subTotals,
      cartTax: totals.tax,
      cartTotal: totals.total,
    });
  };

  // synkroniser local gemte
  syncStorage = () => {
    localStorage.setItem("cart", JSON.stringify(this.state.cart));
  };

  // set single produkt oplysninger på states
  setSingleProduct = (id) => {
    let product = this.state.menu.find((item) => item.nr === id);

    localStorage.setItem("singleProduct", JSON.stringify(product));

    this.setState({
      singleProduct: { ...product },
      loading: false,
      price: product.price,
      price1: product.price1,
      price2: product.price2,
      productName: product.pName,
      productNr: product.nr,
      productTopping: product.topping,
      productprice: product.price,
      pricesingle: product.price,
      extratopping: [],
      size: "Almindelig",
      category: product.category,
    });
  };

  // set single produkt på state og tilføj kurv
  setSingleProductAndAdd = (id) => {
    let product = this.state.menu.find((item) => item.nr === id);
    localStorage.setItem("singleProduct", JSON.stringify(product));

    this.setState(
      {
        singleProduct: { ...product },
        loading: false,
        price: product.price,
        price1: product.price1,
        price2: product.price2,
        productprice: product.price,
        pricesingle: product.price,
        extratopping: [],
        dressing_pizza: false,
        size: "Almindelig",
      },
      () => {
        this.addToCart(this.state.singleProduct);
      }
    );
    this.openCart();
  };

  // set enkle categorie på state
  setSingleCategorie = (categorieName) => {
    let categorie = this.state.menu.filter(
      (item) => item.category === categorieName
    );
    localStorage.setItem("singleCategorie", JSON.stringify(categorie));

    this.setState({
      filteredProducts: [...categorie],
      loading: false,
    });
  };

  // håndtere størelse eller slags skift på produkt
  handleChangeSize = (index) => {
    switch (index) {
      case 0:
        this.setState(
          {
            pricesingle: this.state.price,
            dressingprice: 5,
            toppingprice: 12,
            size: "Almindelig",
          },
          () => {
            this.calcPrice();
          }
        );
        break;
      case 1:
        this.setState(
          {
            pricesingle: this.state.price1,
            dressingprice: 5,
            toppingprice: 12,
            size: "Deeppan",
          },
          () => {
            this.calcPrice();
          }
        );
        break;
      case 2:
        this.setState(
          {
            pricesingle: this.state.price2,
            dressingprice: 8,
            toppingprice: 18,
            size: "Familie",
          },
          () => {
            this.calcPrice();
          }
        );
        break;

      default:
        break;
    }
  };
  // håndtere menu side bar
  handleSidebar = () => {
    this.setState({
      sidebarOpen: !this.state.sidebarOpen,
    });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////
  // 									Kurvside og kurv
  // håndtere kurv side bar
  handleCart = () => {
    this.setState({
      cartOpen: !this.state.cartOpen,
    });
  };
  // lukke kurv side bar
  closeCart = () => {
    this.setState({
      cartOpen: false,
    });
  };
  // åbne kurv side bar
  openCart = () => {
    this.setState({
      cartOpen: true,
    });
  };
  // forhøje antal på produkter i kurven
  increment = (cartItem) => {
    let tempPrice = cartItem.price;
    if (cartItem.size === "Deeppan") tempPrice = cartItem.price1;
    if (cartItem.size === "Familie") tempPrice = cartItem.price2;

    let tempCart = [...this.state.cart];
    const cartItems = tempCart.find(
      (item) => item.nr === cartItem.nr && item.size === cartItem.size
    );
    cartItems.count++;
    cartItems.total = cartItems.count * tempPrice;
    cartItems.total = parseFloat(cartItems.total.toFixed(2));
    this.setState(
      () => {
        return { cart: [...tempCart] };
      },
      () => {
        this.addTotals();
        this.syncStorage();
      }
    );
  };
  // formindske antal på produkter i kurven
  decrement = (cartItem) => {
    let tempCart = [...this.state.cart];
    const cartItems = tempCart.find(
      (item) => item.nr === cartItem.nr && item.size === cartItem.size
    );
    let tempPrice = cartItem.price;
    if (cartItem.size === "Deeppan") tempPrice = cartItem.price1;
    if (cartItem.size === "Familie") tempPrice = cartItem.price2;
    cartItems.count--;
    if (cartItems.count === 0) {
      this.removeItem(cartItem);
    } else {
      cartItems.total = cartItems.count * tempPrice;
      cartItems.total = parseFloat(cartItems.total.toFixed(2));
      this.setState(
        () => {
          return { cart: [...tempCart] };
        },
        () => {
          this.addTotals();
          this.syncStorage();
        }
      );
    }
  };
  // slette produkt fra kurven
  removeItem = (cartItem) => {
    console.log(cartItem);
    let tempCart = [...this.state.cart];
    tempCart = tempCart.filter(
      (item) => !(item.nr === cartItem.nr && item.size === cartItem.size)
    );
    console.log(tempCart);
    this.setState(
      {
        cart: [...tempCart],
      },
      () => {
        this.addTotals();
        this.syncStorage();
      }
    );
  };

  // nulstil kurven
  clearCart = (id) => {
    this.setState(
      {
        cart: [],
      },
      () => {
        this.addTotals();
        this.syncStorage();
      }
    );
    console.log("clear cart");
  };

  // tilføj produkt til kurv
  addToCart = (product) => {
    console.log(product);
    let tempCart = [...this.state.cart];

    let dressing;
    if (this.state.dressing_pizza) {
      dressing = "Dressing";
    }

    //let tempItem = tempCart.find((item) => item.nr === product.nr && item.size === product.size);
    let tempItem = tempCart.find(
      (item) =>
        item.nr === product.nr &&
        item.size === this.state.size &&
        item.extratopping.sort().toString() ===
          this.state.extratopping.sort().toString() &&
        dressing === item.dressing
    );

    if (!tempItem) {
      tempItem = product;
      let total = this.state.productprice;
      let extratopping = this.state.extratopping.sort();
      let size = this.state.size;
      //    let dressing
      //    if (this.state.dressing_pizza) {dressing = "Dressing"};
      let cartItem = {
        ...tempItem,
        count: 1,
        total,
        extratopping,
        dressing,
        size,
      };
      tempCart = [...tempCart, cartItem];
    } else {
      tempItem.count++;
      tempItem.total = this.state.productprice * tempItem.count;
      tempItem.total = parseFloat(tempItem.total.toFixed(2));
    }
    this.setState(
      () => {
        return {
          cart: tempCart,
          extratopping: [],
          dressing_pizza: false,
          productprice: 0,
          size: "Almindelig",
        };
      },
      () => {
        this.addTotals();
        this.syncStorage();
      }
    );
  };

  /////////////////////////////////////////////////////////////////////////////////////////////
  // håndtere leverings metode
  handleChangeDelivery = (event) => {
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState({
      deliveryOption: value,
    });
  };

  // håndtere inputs
  handleChange = (event) => {
    const name = event.target.name;
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState(
      {
        [name]: value,
      },
      () => {
        this.sortData();
        this.setDeliveryPrice();
      }
    );
  };

  // sortere produkter
  sortData = () => {
    const { category, search, menu } = this.state;
    let tempProducts = [...menu];

    if (category !== "Alle") {
      tempProducts = tempProducts.filter((item) => item.category === category);
    }
    if (search.length > 0) {
      tempProducts = tempProducts.filter((item) => {
        let tempSearch = search.toLowerCase();
        let tempTitle = item.pName.toLowerCase().slice(0, search.length);
        if (tempSearch === tempTitle) {
          return item;
        }
      });
    }

    this.setState({
      filteredProducts: tempProducts,
    });
  };
  // set udbringnings pris
  setDeliveryPrice = () => {
    if (this.state.deliveryOption === "Udbringning") {
      if (this.state.postnr >= 1500 && this.state.postnr < 1800) {
        this.setState(
          {
            deliveryPrice: 25,
            errorDelivery: "",
          },
          () => {
            this.addTotals();
          }
        );
        this.addTotals();
      } else if (this.state.postnr >= 1800 && this.state.postnr <= 2000) {
        this.setState(
          {
            deliveryPrice: 35,
            errorDelivery: "",
          },
          () => {
            this.addTotals();
          }
        );
      } else if (this.state.postnr > 2000 && this.state.postnr < 2450) {
        this.setState(
          {
            deliveryPrice: 0,
            errorDelivery: "Vi bringer ikke ud til ønsket postnr",
          },
          () => {
            this.addTotals();
          }
        );
      } else if (this.state.postnr >= 2450 && this.state.postnr <= 2500) {
        this.setState(
          {
            deliveryPrice: 35,
            errorDelivery: "",
          },
          () => {
            this.addTotals();
          }
        );
      } else if (this.state.postnr > 2500 || this.state.postnr < 1000) {
        this.setState(
          {
            deliveryPrice: 0,
            errorDelivery: "Vi bringer ikke ud til ønsket postnr",
          },
          () => {
            this.addTotals();
          }
        );
      } else if (this.state.postnr >= 1000 && this.state.postnr < 1500) {
        this.setState(
          {
            deliveryPrice: 35,
            errorDelivery: "",
          },
          () => {
            this.addTotals();
          }
        );
      }
    }
  };
  // håndtere topping tilføjelser
  handleInputChange = (event) => {
    const target = event.target;
    var name = target.name;
    if (target.checked) {
      this.setState(
        {
          extratopping: [...this.state.extratopping, name],
        },
        () => {
          this.calcPrice();
        }
      );
    } else {
      const filterdetoppig = this.state.extratopping.filter(
        (item) => item !== name
      );
      this.setState(
        {
          extratopping: filterdetoppig,
        },
        () => {
          this.calcPrice();
        }
      );
    }
  };
  // håndtere dressing tilføjelser
  handleInputChangeDressing = (event) => {
    const target = event.target;
    var name = target.name;
    if (target.checked) {
      this.setState(
        {
          dressing_pizza: true,
        },
        () => {
          this.calcPrice();
        }
      );
    } else {
      this.setState(
        {
          dressing_pizza: false,
        },
        () => {
          this.calcPrice();
        }
      );
    }
    console.log(this.state.dressing_pizza);
  };

  // beregne enkle total pris efter tilføjelser
  calcPrice = () => {
    let topping = this.state.extratopping.length * this.state.toppingprice;
    let total;
    if (this.state.dressing_pizza) {
      total =
        parseInt(topping) +
        parseInt(this.state.pricesingle) +
        parseInt(this.state.dressingprice);
    } else {
      total = parseInt(topping) + parseInt(this.state.pricesingle);
    }

    this.setState({
      productprice: total,
    });
  };

  validateForm = () => {
    const {
      deliveryOption,
      telefon,
      navn,
      adress,
      postnr,
      email,
      termsAccepted,
    } = this.state;
    let errors = {};
    let isValid = true;

    if (deliveryOption === "Udbringning") {
      // Address validation
      if (!adress.trim()) {
        errors.adress = "Udfyld adresse";
        isValid = false;
      }
      // Postcode validation
      if (!postnr.trim()) {
        errors.postnr = "Udfyld postnr";
        isValid = false;
      }
    }
    // Name validation
    if (!navn.trim()) {
      errors.navn = "Udfyld navn";
      isValid = false;
    }

    // Telephone validation
    if (!telefon.trim()) {
      errors.telefon = "Udfyld telefon";
      isValid = false;
    }

    if (!termsAccepted) {
      errors.termsAccepted = "Accepter betingelserne";
      isValid = false;
    }
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.match(emailRegex)) {
      errors.email = "Email er ikke gyldig";
      isValid = false;
    }

    this.setState({ errors });
    return isValid;
  };

  handleContactForm = (e) => {
    e.preventDefault();

    if (this.validateForm()) {
      // Form is valid, you can submit the data or perform other actions here
      console.log("Form submitted with data:", this.state);
      console.log(this.state.cart);

      this.sendOrder();
    } else {
      // Form is not valid, handle the errors or display a message
      console.log("Form has validation errors");
    }
  };
  sendOrder = async () => {
    console.log(this.state.cart);
    const res = await axios.post(`${API_URL}/cart`, {
      name: this.state.navn,
      email: this.state.email,
      adress: this.state.adress,
      telephone: this.state.telefon,
      postnr: this.state.postnr,
      orderType: this.state.deliveryOption,
      paymentType: "Kontant",
      comment: this.state.message,
      deliveryFee: this.state.deliveryPrice,
      cart: this.state.cart,
    });
    console.log(res);
    this.handleModalOpen();
    this.clearFormInputs();
  };
  shopOpenTime = () => {
    const d = new Date("December 12, 2023 17:13:00");
    let hour = d.getHours();
    let min = d.getMinutes();
    let day = d.getDay();
    let h = hour + "." + min;
    let result = false;
    if (day >= 1 && day <= 4) {
      if (hour >= 16 && parseFloat(h) <= 22.3) {
        result = true;
      }
    } else if (day === 5) {
      if (hour >= 16 && parseFloat(h) <= 23.59) {
        result = true;
      }
    } else if (day === 6) {
      if (hour >= 12 && parseFloat(h) <= 23.59) {
        result = true;
      } else if (hour >= 0 && parseFloat(h) <= 2.0) {
        result = true;
      }
    } else if (day === 0) {
      if (hour >= 12 && parseFloat(h) <= 21.3) {
        result = true;
      } else if (hour >= 0 && parseFloat(h) <= 2.0) {
        result = true;
      }
    }
    return result;
  };

  render() {
    return (
      <ProductContext.Provider
        value={{
          ...this.state,
          shopOpenTime: this.shopOpenTime,
          handleSidebar: this.handleSidebar,
          handleCart: this.handleCart,
          closeCart: this.closeCart,
          openClart: this.openCart,
          addTotals: this.addTotals,
          addToCart: this.addToCart,
          setSingleProduct: this.setSingleProduct,
          setSingleCategorie: this.setSingleCategorie,
          increment: this.increment,
          decrement: this.decrement,
          removeItem: this.removeItem,
          clearCart: this.clearCart,
          handleChange: this.handleChange,
          handleChangeSize: this.handleChangeSize,
          handleInputChange: this.handleInputChange,
          handleInputChangeDressing: this.handleInputChangeDressing,
          calcPrice: this.calcPrice,
          submit: this.submit,
          setSingleProductAndAdd: this.setSingleProductAndAdd,
          handleChangeDelivery: this.handleChangeDelivery,
          handleLogin: this.handleLogin,
          handleLogout: this.handleLogout,
          authListener: this.authListener,
          deleteProduct: this.deleteProduct,
          addProduct: this.addProduct,
          updateProduct: this.updateProduct,
          handleModalOpen: this.handleModalOpen,
          handleModalClose: this.handleModalClose,
          fetchdata: this.fetchdata,
          handleContactForm: this.handleContactForm,
        }}
      >
        {this.props.children}
      </ProductContext.Provider>
    );
  }
}

const ProductConsumer = ProductContext.Consumer;

export { ProductProvider, ProductConsumer };
